import React from 'react';
import PropTypes from 'prop-types';
import {
  availableAccountRoutes,
  availablePaymentRoutes,
  bonusesAvailableRoutes,
  CLIENT_PROFILE_COMPONENT_TYPES,
  historyAvailableRoutes,
  responsibleGamingAvailableRoutes,
} from '@atlas/routing';
import ClientProfileSubNavigation from 'components/ClientProfile/ClientProfileSubNavigation';
import { HeaderTitle } from '@atlas/ui';

const availableTabsByComponentType = {
  [CLIENT_PROFILE_COMPONENT_TYPES.PROFILE]: availableAccountRoutes,
  [CLIENT_PROFILE_COMPONENT_TYPES.PAYMENT]: availablePaymentRoutes,
  [CLIENT_PROFILE_COMPONENT_TYPES.HISTORY]: historyAvailableRoutes,
  [CLIENT_PROFILE_COMPONENT_TYPES.RESPONSIBLE_GAMING]: responsibleGamingAvailableRoutes,
  [CLIENT_PROFILE_COMPONENT_TYPES.BONUSES]: bonusesAvailableRoutes,
};

const ExpandedNavigationItem = ({ name, type, tabs, link }) => {
  const availableTabs = availableTabsByComponentType[type];

  return (
    <div className="user-profile-group-item">
      <div className="title-wrapper">
        <HeaderTitle title={name} className="sub-text block-small border" />
      </div>
      <ClientProfileSubNavigation tabs={tabs} availableTabs={availableTabs} parentRoute={link} />
    </div>
  );
};

ExpandedNavigationItem.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  tabs: PropTypes.array.isRequired,
  link: PropTypes.string.isRequired,
};

export default ExpandedNavigationItem;
